import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="session-timeout-handler"
export default class extends Controller {
  connect() {
    document.addEventListener("turbo:before-fetch-response", this.handleFetchResponse);
    window.addEventListener("pageshow", this.handlePageShow);
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-response", this.handleFetchResponse);
    window.removeEventListener("pageshow", this.handlePageShow);
  }

  handleFetchResponse = (event) => {
    const response = event.detail.fetchResponse;

    if (response.response.status === 401 ||
        (response.response.redirected && response.response.url.includes("/users/sign_in"))) {
      event.preventDefault();
      window.location.href = "/users/sign_in";
    }
  }

  handlePageShow = (event) => {
    if (!event.persisted) return;
    if (!window.location.pathname.includes("/sign_in")) return;

    window.location.reload();
  }
}
